import m from "mithril"
import { state } from "../state/store.js"

export default {
  view: function (vnode) {
    var project = vnode.attrs.project
    var index = vnode.attrs.index || 0
    var label = state.categoryLabels[project.category] || project.category

    return m("article.card", {
      key: project.id,
      style: { "animation-delay": (index * 0.06) + "s" },
      onclick: function () {
        m.route.set("/project/:id", { id: project.id })
      },
    }, [
      m("div.card-image", [
        m("img", { src: project.image, alt: project.title, loading: "lazy" }),
        m("div.card-overlay", [
          m("span.card-overlay-text", [
            "View Project",
            m("svg", { width: 14, height: 14, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
              m("path", { d: "M5 12h14M12 5l7 7-7 7" })),
          ]),
        ]),
      ]),
      m("div.card-body", [
        m("div.card-tags", [
          m("span.card-tag", label),
        ]),
        m("h3.card-title", project.title),
        m("p.card-description", project.description),
      ]),
      m("div.card-footer", [
        m("span.card-year", project.year),
        m("span.card-arrow", [
          m("svg", { width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2 },
            m("path", { d: "M7 17L17 7M17 7H7M17 7v10" })),
        ]),
      ]),
    ])
  },
}
